// extracted by mini-css-extract-plugin
module.exports = {"titledivider":"titledivider--knZnE","titlecontainer":"titlecontainer--llbf5"};